// components/MultiSelectFilter.jsx
import { useState, useRef, useEffect } from "react";

const MultiSelectFilter = ({ options, selectedValues, onChange, placeholder }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const toggleValue = (val) => {
    if (selectedValues.includes(val)) {
      onChange(selectedValues.filter((v) => v !== val));
    } else {
      onChange([...selectedValues, val]);
    }
  };

  const handleSelectAll = () => {
    if (selectedValues.length === options.allValues.length) {
      onChange([]);
    } else {
      onChange([...options.allValues]);
    }
  };

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const visibleSelectedCount = selectedValues.filter((v) =>
    options.visibleValues.has(String(v))
  ).length;

  const labelText =
    visibleSelectedCount === 0
      ? placeholder
      : `${visibleSelectedCount} selected`;

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        className="border text-sm px-2 py-1 rounded bg-gray-100 hover:bg-gray-200 w-full text-left"
        onClick={() => setOpen(!open)}
      >
        {labelText} ▾
      </button>

      {open && (
        <div className="w-[100%] absolute z-20 mt-1 bg-white border rounded shadow-lg max-h-60 overflow-auto">
          <div className="p-2 border-b">
            <label className="flex items-center space-x-2 cursor-pointer">
              <input
                type="checkbox"
                checked={selectedValues.length === options.allValues.length}
                onChange={handleSelectAll}
              />
              <span className="text-sm font-medium">Select All</span>
            </label>
          </div>

          {options.allValues.map((value) => {
            const isVisible = options.visibleValues.has(String(value));
            const isChecked = selectedValues.includes(value);

            return (
              <label
                key={value}
                className={`flex items-center px-2 py-1 space-x-2 cursor-pointer ${
                  !isVisible ? "opacity-40 cursor-not-allowed" : "hover:bg-gray-50"
                }`}
              >
                <input
                  type="checkbox"
                  checked={isChecked}
                  disabled={!isVisible}
                  onChange={() => {
                    if (isVisible) toggleValue(value);
                  }}
                />
                <span className="text-sm">{value}</span>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MultiSelectFilter;
